import script from "./NotFoundView.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./NotFoundView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundView.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./NotFoundView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__